(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[552],{

/***/ 34183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(41577);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/Layout.tsx + 13 modules
var Layout = __webpack_require__(78690);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/about-us-photo.png
/* harmony default export */ var about_us_photo = ({"src":"/_next/static/media/about-us-photo.3a5b881e.png","height":1849,"width":1080,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAUVBMVEXWs4+HZlvbt52BWFW6j4afb29iRkDIlI+0iIG0gHKyqaK5goLQqpXCmWydhWDCtqfc19RnT0+RkpanjYFLPDOkpKXApYG2mX1sY16lfHfo5OIuPoJSAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAM0lEQVR4nAXBhQHAIBAAsUMfa6li+w9KwvOna5HG/VbaN9VJN8ofWHFeI9kZDSHYAjEKGzG+AZ7uNLyrAAAAAElFTkSuQmCC","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./components/aboutUs/AboutUs.tsx






var AboutUs = function() {
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: classes.imageSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.imageContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: about_us_photo
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: classes.textSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h2",
                            component: "h1",
                            children: "TOTEMNOTES"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            component: "h2",
                            children: "Твоя особлива канцелярія!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            children: "ПРИВІТ!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            component: "p",
                            children: "Я Наталія - графічний дизайнер та засновник бренду креативної канцелярії - Totemnotes."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            component: "p",
                            children: "Працюючи фрілансером, я почала цікавитися плануванням та організацією часу."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            component: "p",
                            children: "Для цього мені був необхідний планер, але асортимент на українському ринку дуже засмучував: неякісні матеріали та застарілий дизайн. Саме тоді я вирішила використати свої знання з дизайну та друкарських процесів для того, щоб створити власний зручний та стильний планер. Так в 2019 році виник бренд під назвою Totemnotes."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            component: "p",
                            children: "На сьогоднішній день в нашому інтернет-магазині представлений великий вибір планерів, записників, стікерів, ручок та іншої креативної канцелярії."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            children: "Totemnotes - канцелярія, яку ти полюбиш!"
                        })
                    ]
                })
            ]
        })
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: (0,_define_property/* default */.Z)({
            display: "flex",
            flexDirection: "column-reverse",
            gap: theme.spacing(4),
            paddingBottom: theme.spacing(4)
        }, theme.breakpoints.up("md"), {
            flexDirection: "row",
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(10)
        }),
        imageSection: {
            display: "flex",
            justifyContent: "center"
        },
        imageContainer: (0,_define_property/* default */.Z)({
            maxWidth: 361
        }, theme.breakpoints.up("md"), {
            minWidth: 361
        }),
        textSection: {
            "& h2": {
                marginBottom: theme.spacing(5)
            },
            "& h3": {
                marginBottom: theme.spacing(1.5)
            },
            "& p": {
                marginBottom: theme.spacing(1.5)
            }
        }
    };
});
/* harmony default export */ var aboutUs_AboutUs = (AboutUs);

;// CONCATENATED MODULE: ./pages/about-us.tsx




var AboutUsPage = function(param) {
    var pageMeta = param.pageMeta;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        pageMeta: pageMeta,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(aboutUs_AboutUs, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var about_us = (AboutUsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,351,690,774,888,179], function() { return __webpack_exec__(34183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);